export const IconWallet2 = ({ style, className }) => {
  return (
    <svg
      style={style}
      className={className}
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M66.0006 32.9099V39.0901C66.0006 40.7401 64.6806 42.09 63.0006 42.15H57.1206C53.8806 42.15 50.9107 39.78 50.6407 36.54C50.4607 34.65 51.1806 32.88 52.4406 31.65C53.5506 30.51 55.0806 29.85 56.7606 29.85H63.0006C64.6806 29.91 66.0006 31.2599 66.0006 32.9099Z" fill="white"/>
      <path opacity="0.4" d="M52.4399 31.65C51.1799 32.88 50.46 34.65 50.64 36.54C50.91 39.78 53.8799 42.15 57.1199 42.15H63V46.5C63 55.5 57 61.5 48 61.5H21C12 61.5 6 55.5 6 46.5V25.5C6 17.34 10.92 11.64 18.57 10.68C19.35 10.56 20.16 10.5 21 10.5H48C48.78 10.5 49.53 10.53 50.25 10.65C57.99 11.55 63 17.28 63 25.5V29.85H56.7599C55.0799 29.85 53.5499 30.51 52.4399 31.65Z" fill="white"/>
      <path d="M39 29.25H21C19.77 29.25 18.75 28.23 18.75 27C18.75 25.77 19.77 24.75 21 24.75H39C40.23 24.75 41.25 25.77 41.25 27C41.25 28.23 40.23 29.25 39 29.25Z" fill="#292D32"/>
    </svg>
  );
};
